import { useOrgInfo } from '../../../global/auth/use-org-info/use-org-info';

/**
 * Matches the sidebar's `packageConfig ? !packageConfig.X : false` handling: a tenant with no
 * package, such as one on trial, gets the feature. Nothing is granted until org info resolves.
 */
export const useAdvancedCommunicationsState = (): { advanced: boolean; loading: boolean } => {
  const orgInfo = useOrgInfo();
  if (!orgInfo) return { advanced: false, loading: true };
  const { packageConfig } = orgInfo;
  return { advanced: packageConfig ? packageConfig.advancedCommunications : true, loading: false };
};

export const useAdvancedCommunications = (): boolean => useAdvancedCommunicationsState().advanced;
